// Application constants
export const SEATS_PER_BUS = 23;
export const PRICE_PER_PASSENGER = 100;
export const ITEMS_PER_PAGE_OPTIONS = [10, 25, 50, "all"];
export const DAILY_ANALYSIS_ITEMS_PER_PAGE = 10;

// Seat utilization thresholds
export const SEAT_UTILIZATION = {
  HIGH: 70,
  MEDIUM: 40,
  LOW: 0,
};

// Colors for seat utilization
export const UTILIZATION_COLORS = {
  HIGH: "bg-green-100 text-green-800",
  MEDIUM: "bg-yellow-100 text-yellow-800",
  LOW: "bg-red-100 text-red-800",
};

// Weekday names in Thai
export const WEEKDAY_NAMES = {
  0: "อาทิตย์",
  1: "จันทร์",
  2: "อังคาร",
  3: "พุธ",
  4: "พฤหัสบดี",
  5: "ศุกร์",
  6: "เสาร์",
};

// Chart colors for weekly chart
export const WEEKLY_CHART_COLORS = [
  "#EF4444", // Sunday - Red
  "#3B82F6", // Monday - Blue
  "#10B981", // Tuesday - Green
  "#F59E0B", // Wednesday - Yellow
  "#8B5CF6", // Thursday - Purple
  "#06B6D4", // Friday - Cyan
  "#F97316", // Saturday - Orange
];

// Year colors for timeline charts (consistent across all charts)
export const YEAR_COLORS = [
  "#3B82F6", // Blue - 2025
  "#10B981", // Green - 2024
  "#F59E0B", // Amber - 2023
  "#EF4444", // Red - 2022
  "#8B5CF6", // Purple - 2021
  "#EC4899", // Pink - 2020
  "#06B6D4", // Cyan - 2019
  "#F97316", // Orange - 2018
];

// Local storage keys
export const STORAGE_KEYS = {
  BUS_DATA: "busData",
};

// Sample data for routes, trips, etc.
export const SAMPLE_ROUTES = ["สาย 1", "สาย 2", "สาย A", "สาย B", "สาย C"];
export const SAMPLE_TRIPS = [
  "เที่ยวที่ 1",
  "เที่ยวที่ 2",
  "รอบเช้า",
  "รอบบ่าย",
  "รอบเย็น",
];
export const SAMPLE_LICENSES = [
  "กข 1234",
  "กข 5678",
  "ขค 9012",
  "คง 3456",
  "งจ 7890",
];
export const SAMPLE_DRIVERS = [
  "สมชาย ใจดี",
  "สมหญิง รักงาน",
  "วิชัย ขยัน",
  "มาลี ซื่อสัตย์",
  "ประยุทธ มั่นคง",
];
export const SAMPLE_BUS_STOPS = [
  { name: "ป้ายโรงพยาบาล", passengers: [15, 25, 30, 20, 18] },
  { name: "ป้ายตลาดสด", passengers: [20, 35, 40, 25, 22] },
  { name: "ป้ายโรงเรียน", passengers: [25, 45, 50, 30, 28] },
  { name: "ป้ายสถานีรถไฟ", passengers: [30, 40, 45, 35, 32] },
  { name: "ป้ายห้างสรรพสินค้า", passengers: [18, 28, 35, 22, 20] },
];
